export default __webpack_public_path__ + "static/card2-tablet-b7ae76c531bafe688c43a617992d862f.png";